// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YRCE1","questions":"styles_questions__4ROvD","footer":"styles_footer__3ecXc"};